$mol_vary_edit $mol_list
	schema null
	value? null
	Vary $mol_vary_class
	selection? /
	Null_icon $mol_icon_circle_off_outline
	Bool_icon $mol_icon_flag_checkered
	Bint_icon $mol_icon_pound
	Real_icon $mol_icon_division
	Date_icon $mol_icon_clock_outline
	Text_icon $mol_icon_card_text_outline
	List_icon $mol_icon_format_list_bulleted
	Tupl_icon $mol_icon_table
	rows /
		<= Head $mol_bar sub /
			<= Type_drop $mol_drop
				adopt? <=> item_adopt? null
				receive? <=> type_receive? null
				Sub <= Type $mol_select
					Filter null
					Trigger_icon null
					option_label* => type_label*
					option_content* <= type_option_content* /
						<= Type_icon* $mol_icon
						<= type_label*
					enabled <= type_mutable <= enabled true
					dictionary <= type_dict *
						Null \Nothing
						Bool \Boolean
						Bint \Integer
						Real \Real
						Text \Text
						List \Array
						Tupl \Dictionary
					value? <=> type? <= type_auto \Null
			^ head /
				<= Bool $mol_check_box
					checked? <=> bool? false
					enabled <= enabled true
				<= Bint $mol_bigint_field
					value? <=> bint? 0n
					enabled <= enabled true
					selection? <=> text_selection? /number
				<= Real $mol_number
					value? <=> real? 0
					enabled <= enabled true
					selection? <=> text_selection? /number
				<= Date $mol_date
					value_moment? <=> date? $mol_time_moment
					enabled <= enabled true
				<= Text $mol_textarea
					value? <=> text? \
					enabled <= enabled true
					selection? <=> text_selection? /number
				<= Item_expand $mol_check_expand
					expanded? <=> expanded? true
				<= Item_add $mol_button_minor
					click? <=> item_add? null
					enabled <= enabled true
					sub /
						<= Item_add_icon $mol_icon_plus
				<= Field_add $mol_string
					hint \+
					submit? <=> field_add? null
					enabled <= enabled true
					sub /
						<= Field_add_icon $mol_icon_plus
		<= Body $mol_list rows <= body /
			<= Item*0 $mol_bar sub /
				<= Item_drop* $mol_drop
					adopt? <=> item_adopt? null
					receive? <=> item_receive*? null
					Sub <= Item_drag* $mol_drag
						drag_end? <=> item_drag_end*? null
						transfer *
							text/plain <= transfer_vary* \
							text/html \
							text/uri-list <= transfer_vary* \
						Sub <= Item_key* $mol_view
							sub /
								<= item_key* null
				<= Item_val* $mol_vary_edit
					enabled <= enabled true
					value? <=> item_val*? null
					selection? <=> item_selection*? /
